import React from 'react';
import './ToggleExpand.styl';

interface ToggleExpandProps {
  expanded?: boolean;
  onToggle: React.MouseEventHandler;
}

/**
 * Expand/collapse toggle.
 */
const ToggleExpand: React.FC<ToggleExpandProps> = ({expanded, onToggle}) => {
  return (
    <div className="toggle-expand" onClick={onToggle}>
      {expanded ? '-' : '+'}
    </div>
  );
};

export default ToggleExpand;
